import React, { useCallback, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import { ErrorToaster, successToaster } from "components/common/toast";
import {
  GetAIPromptAPI,
  ResetAIPromptAPI,
  SaveAIPromptAPI,
} from "network/user";

// Istruzioni con cui l'AI cerca i dati mancanti dei vini ("Richiedi all'AI").
// Le modifica solo il super admin; formato della risposta e regole di sicurezza restano fisse.
const AIPromptCard = () => {
  const { t } = useTranslation("account");
  const [state, setState] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState("");

  const apply = (data) => {
    setState(data);
    setText(data?.prompt || "");
  };

  const load = useCallback(async () => {
    try {
      const response = await GetAIPromptAPI();
      apply(response?.data || null);
    } catch (error) {
      ErrorToaster(error?.message || t("aiPrompt.loadError"));
    }
  }, [t]);

  useEffect(() => {
    load();
  }, [load]);

  const run = async (name, action, message) => {
    setBusy(name);
    try {
      const response = await action();
      apply(response?.data || null);
      successToaster(message);
    } catch (error) {
      ErrorToaster(error?.message || t("aiPrompt.failed"));
    } finally {
      setBusy("");
    }
  };

  const max = state?.max_length || 4000;
  const changed = text.trim() !== (state?.prompt || "").trim();

  return (
    <Row>
      <Col lg="12">
        <Card className="p-3">
          <CardHeader>
            <h3 className="title">{t("aiPrompt.title")}</h3>
          </CardHeader>
          <CardBody>
            <p>
              {t("aiPrompt.intro1")}{" "}
              <strong>{state?.is_custom ? t("aiPrompt.custom") : t("aiPrompt.standard")}</strong>.{" "}
              {t("aiPrompt.intro2")}
            </p>
            <Input
              type="textarea"
              rows={12}
              maxLength={max}
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <small className="text-muted">
              {t("aiPrompt.counter", { length: text.length, max })}
            </small>
            <div className="mt-3">
              <BtnCustom
                className="btn-fill mr-2"
                color="primary"
                type="button"
                submittingText={t("aiPrompt.saving")}
                isLoading={busy === "save"}
                disabled={!text.trim() || !changed || !!busy}
                onClick={() =>
                  run("save", () => SaveAIPromptAPI(text), t("aiPrompt.saved"))
                }
              >
                {t("aiPrompt.save")}
              </BtnCustom>
              {state?.is_custom && (
                <BtnCustom
                  color="secondary"
                  type="button"
                  submittingText={t("aiPrompt.resetting")}
                  isLoading={busy === "reset"}
                  disabled={!!busy}
                  onClick={() =>
                    run("reset", ResetAIPromptAPI, t("aiPrompt.resetDone"))
                  }
                >
                  {t("aiPrompt.reset")}
                </BtnCustom>
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AIPromptCard;
